import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function ModalBody({ children, noPadding }) {
	return (
		<div className={classnames('modal-body', { 'no-padding': noPadding })}>
			{children}
		</div>
	);
}

ModalBody.propTypes = {
	children: PropTypes.node,
	noPadding: PropTypes.bool,
};
